(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" ng-if="!$ctrl.conflict">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('jotApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];
        vm.conflict = false;

        function addErrorAlert (message, key, data) {
            if(data === undefined || (data.fieldName !== "jotApp.invitationDTO.authority" && data.fieldName !== "jotApp.invitationDTO.domains")){
                key = key && key !== null ? key : message;
            } else {
                key = message.replace('jotApp.invitationDTO.', '');
            }
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('jotApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();

            function showCustomError(){
                var entityName;
                var entityKey = httpResponse.headers('X-jotApp-params');
                if(entityKey) {
                    entityName = $translate.instant(entityKey);
                }
                else{
                    entityName = httpResponse.headers('X-jotApp-value');
                }
                addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
            }
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                vm.conflict = false;
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                vm.conflict = false;
                var errorHeader = httpResponse.headers('X-jotApp-error');
                if (errorHeader) {
                    showCustomError();
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('jotApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.description, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 409:
                vm.conflict = true;
                break;

            default:
                vm.conflict = false;
                var errorHeader = httpResponse.headers('X-jotApp-error');
                if (errorHeader) {
                    showCustomError();
                }
                else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.description);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
                vm.conflict = false;
            }
        });
    }
})();
